import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';

import './utils/request.js';
import './components/global-less.less';
import './plugins/element.js';
import 'normalize.css/normalize.css';
import {
  Notification
} from 'element-ui';

Vue.config.productionTip = false;

// Vue.config.devtools = false;

// 路由免登陆白名单
const WHITE_LIST = ['Login', 'LoginPage', 'Register', 'FindPassword', 'ApplyTrial', 'AppList', 'AppDownloadPage', 'Protocol']

// 路由
router.beforeEach((to, from, next) => {
  Nprogress.start();
  // 访问免登陆白名单，直接进入
  if (WHITE_LIST.indexOf(to.name) !== -1) {
    next();
    return
  }
  const token = store.getters.token

  if (!token) {
    Notification.error({
      title: '403',
      message: '暂无权限访问该页面，请重新登录',
      duration: 2000,
      onClose: () => {
        next('/login');
      }
    });
  } else {
    next();
  }

});

router.afterEach(() => {
  Nprogress.done();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
